// extracted by mini-css-extract-plugin
export default {"content":"InfoPopup_content__kxHqA"};